import { v5 as uuidV5 } from 'uuid'
import { createTimestamp, createTraceId, Platform } from 'web-event-collector'

export function makeDeviceId(userAgent: string, userId: number): string {
  return uuidV5(`${userAgent}-${userId}`, uuidV5.URL)
}

export interface WebCommonEvent {
  TraceId: string
  Body: {
    fromWebView: boolean
    deviceId: string
    platform: Platform.Web
    appVersion: '1.0.0'
    userId: number
  }
  Timestamp: number
}

export function createCommonEvent(userAgent: string, userId: number): WebCommonEvent {
  return {
    TraceId: createTraceId(),
    Body: {
      fromWebView: false,
      deviceId: makeDeviceId(userAgent, userId),
      platform: Platform.Web,
      appVersion: '1.0.0',
      userId,
    },
    Timestamp: createTimestamp(),
  }
}
